export default "__VITE_ASSET__CkUZhP_r__"